import { render, staticRenderFns } from "./commonAside.vue?vue&type=template&id=610a3244&scoped=true&"
import script from "./commonAside.vue?vue&type=script&lang=js&"
export * from "./commonAside.vue?vue&type=script&lang=js&"
import style0 from "./commonAside.vue?vue&type=style&index=0&id=610a3244&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610a3244",
  null
  
)

export default component.exports